import Link from 'next/link';
import type { CommentContentProps } from '../types';

export const CommentContent = ({ author, content }: CommentContentProps) => {
	const parts = content.split(/(@\w+)/g);

	return (
		<div>
			<div className="font-semibold text-[14px] text-green-600 leading-none mb-1">
				<Link href={`/users/${author.id}`}>{author.name}</Link>
			</div>
			<p className="text-[14px] text-secondary-black leading-[1.4]">
				{parts.map((part, index) =>
					part.startsWith('@') ? (
						// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
						<span key={part + index} className="text-blue-600">
							{part}
						</span>
					) : (
						// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
						<span key={part + index}>{part}</span>
					),
				)}
			</p>
		</div>
	);
};
